import app from "../firebase";
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
} from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import router from "@/router";
import Notify from 'quasar/src/plugins/Notify.js';;

const db = getFirestore(app);

const state = {
  loadingStatus: false,
};
const mutations = {
  setLoadingStatus(state, payload) {
    state.loadingStatus = payload;
  },
};
const actions = {
  async registerUser({ commit }, payload) {
    const auth = getAuth();
    let sanitizedEmail = payload.email.replace(/\s/g, "");
    commit("setLoadingStatus", true);
    try {
      // REGISTER USER
      let usr = await createUserWithEmailAndPassword(
        auth,
        sanitizedEmail,
        payload.password
      );
      // CREATE USER ENTRY IN DB
      await setDoc(doc(db, "users", usr.user.uid), {
        name: payload.name,
        lastName: payload.lastName,
        email: sanitizedEmail,
      });
      // SEND EMAIL VALIDATION
      await sendEmailVerification(auth.currentUser);
      await signOut(auth);
      Notify.create({
        message: "Email verification sent!",
        color: "green-6",
        icon: "check",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 4000,
      });
      router.push("/login");
    } catch (err) {
      console.log(err);
      return;
    }
    commit("setLoadingStatus", false);
  },
  async loginUser({ commit }, payload) {
    let email = payload.email.replace(/\s/g, "");
    let password = payload.password;
    commit("setLoadingStatus", true);
    const auth = getAuth();
    let credentials;
    try {
      credentials = await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      Notify.create({
        message: "Login error",
        color: "red-6",
        icon: "error",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 4000,
      });
      commit("setLoadingStatus", false);
      return;
    }
    if (!credentials.user.emailVerified) {
      Notify.create({
        message: "Email is not verified",
        color: "red-6",
        icon: "error",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 4000,
      });
      commit("setLoadingStatus", false);
      return;
    } else {
      router.push("/");
      commit("setLoadingStatus", false);
    }
  },
  async logoutUser() {
    const auth = getAuth();
    try {
      await signOut(auth);
      Notify.create({
        message: "Logout successful",
        color: "green-6",
        icon: "check",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 1000,
      });
    } catch (err) {
      console.log(err);
    }
  },
  async sendPasswordReset({ commit }, payload) {
    commit("setLoadingStatus", true);
    const auth = getAuth();
    await sendPasswordResetEmail(auth, payload);
    commit("setLoadingStatus", false);
    router.push("/login");
    Notify.create({
      message: "Password reset email sent succesfuly",
      color: "green-6",
      icon: "check",
      badgeColor: "amber-6",
      progress: true,
      classes: "pc-font pc-semibold higher-toast",
      timeout: 4000,
    });
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
